import { defineComponent } from "vue";
const _sfc_main = defineComponent({
  name: "SprayPaint"
});
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 24 24"
};
const _hoisted_2 = /* @__PURE__ */ _createElementVNode("path", {
  "fill-rule": "evenodd",
  d: "M21 6.375H19.5V2.625H14.25V6.375H12.75C11.9219 6.37583 11.2508 7.04692 11.25 7.875V21.375C11.2508 22.2031 11.9219 22.8742 12.75 22.875H21C21.8279 22.8738 22.4988 22.2029 22.5 21.375V7.875C22.4992 7.04692 21.8281 6.37583 21 6.375ZM15.75 4.125H18V6.375H15.75V4.125ZM12.75 7.875V21.375H21.0015L21 7.875H12.75ZM1.5 10.875H3.75V13.125H1.5V10.875ZM7.5 7.125H5.25V9.375H7.5V7.125ZM1.5 7.125H3.75V9.375H1.5V7.125ZM11.25 3.375H9V5.625H11.25V3.375ZM5.25 3.375H7.5V5.625H5.25V3.375ZM3.75 3.375H1.5V5.625H3.75V3.375ZM16.875 17.25C15.011 17.25 13.5 15.739 13.5 13.875C13.5 12.011 15.011 10.5 16.875 10.5C18.739 10.5 20.25 12.011 20.25 13.875C20.2479 15.7381 18.7381 17.2479 16.875 17.25ZM15 13.875C15 12.8395 15.8395 12 16.875 12C17.91 12.0012 18.7488 12.84 18.75 13.875C18.75 14.9105 17.9105 15.75 16.875 15.75C15.8395 15.75 15 14.9105 15 13.875Z",
  "clip-rule": "evenodd"
}, null, -1);
const _hoisted_3 = [
  _hoisted_2
];
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3);
}
import _export_sfc from "/plugin-vue/export-helper";
export default /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render], ["__file", "/Users/yimingtian/projects/ym/yimian-ui/packages/icons/src/SprayPaint.vue"]]);
